module.exports = __webpack_public_path__ + "static/media/icon_zhunquelv.0c707ba7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/icon_zhunquelv.svg
// module id = 552
// module chunks = 0